module.exports = __webpack_public_path__ + "static/media/leptophyes_punctatissima_BD_001_APA.07667f95.png";